export default __webpack_public_path__ + "static/media/straight.75023118.svg";